// extracted by mini-css-extract-plugin
module.exports = {"blogs__schema":"_9e1425b4d3--blogs__schema--JlNFi","blogs-wrap":"_9e1425b4d3--blogs-wrap--wi6jN","blogs":"_9e1425b4d3--blogs--WTIhO"};